import React from "react";
import DataTable from "react-data-table-component";
import moment from "moment";
import Select from "react-select";
// react-bootstrap components
import {
  Badge,
  Button,
  Card,
  Form,
  InputGroup,
  Navbar,
  Nav,
  TabContent,
  TabPane,
  Container,
  Collapse,
  Row,
  Col,
  Tab,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { number } from "prop-types";
import DetailPengajuan from "./TabPengajuan/indexSteps";
import { useDispatch, useSelector } from "react-redux";
import { getAllPengajuan, jsonPengajuan } from "stores/Pengajuan/function";
import { getAllStatusPengajuan } from "stores/Pengajuan/function";
import { Dna } from "react-loader-spinner";
import ReactPaginate from "react-paginate";
import "./Pagination.css";
import { getAllWilayah } from "stores";
import SplitText from "views/SplitText";
import Swal from "sweetalert2";

function Pengajuan() {
  const [currentPage, setCurrentPage] = React.useState(1);
  const itemsPerPage = 10;
  const modalDetailPengajuan = useSelector((state) => state.pengajuanReducer);
  const wilayah = useSelector((state) => state.dashboardUtamaReducer);
  const pengajuan = useSelector((state) => state.pengajuanReducer);
  const auth = useSelector((state) => state.authReducer);

  // console.log(pengajuan.listPengajuan.data, "Dari Store");
  const dispatch = useDispatch();
  const [listPengajuan, setListPengajuan] = React.useState([]);
  const [filterStatus, setFilterStatus] = React.useState(null);
  const [listStatus, setListStatus] = React.useState([]);
  const [searchText, setSearchText] = React.useState("");
  const [isLoading, setIsLoading] = React.useState(true);
  const [totalPerHalaman, setTotalPerHalaman] = React.useState(10);
  const [page, setPage] = React.useState(0);
  const [pilihOpsi, setPilihOpsi] = React.useState("");
  const [listWilayah, setListWilayah] = React.useState([]);
  const [idWilayah, setIdWilayah] = React.useState({
    label: "All",
    value: "",
  });
  const handlePageSizeChange = (selectedOption) => {
    setTotalPerHalaman(selectedOption.value);
  };

  const handleFilterChange = () => {
    setIsLoading(true);
    setPage(0);
    getAllPengajuan(dispatch, {
      tglAwal: "",
      tglAkhir: "",
      status: pilihOpsi,
      page: 1,
      limit: totalPerHalaman,
      cari: searchText,
      idWilayah: idWilayah.value,
    })
      .then((response) => {
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Terjadi kesalahan saat memuat data.",
        });
      });
  };

  const handleAnimationComplete = () => {
    console.log("All letters have animated!");
  };

  const handleDetailsClick = (val) => {
    dispatch({ type: "SET_STEP_PENGAJUAN", data: false });
    dispatch({ type: "SET_DETAIL_PENGAJUAN", data: val });
  };

  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };

  const handleClearSearch = () => {
    setSearchText("");
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleFilterChange();
    }
  };

  React.useEffect(() => {
    if (pengajuan.listPengajuan.data) {
      let tmp = pengajuan.listPengajuan.data.map((val) => {
        // console.log(val, "LLLL");
        return {
          ...val,
          namaCabangPencairan: !val.lokasiPencairan
            ? "-"
            : val.lokasiPencairan.namaCabang,
          action: (
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip>Details Pengajuan</Tooltip>}
            >
              <Button
                className="btn-icon mx-1 shadow-sm d-flex align-items-center justify-content-center"
                style={{
                  width: "36px",
                  height: "36px",
                  borderRadius: "10px",
                  backgroundColor: "#F75D59",
                  border: "none",
                  color: "white",
                }}
                onClick={() => handleDetailsClick(val)}
              >
                <i className="fas fa-eye" style={{ fontSize: "14px" }}></i>
              </Button>
            </OverlayTrigger>
          ),
          action1: (
            <>
              <>
                {/* <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip>Dokumen Pernyataan Nasabah</Tooltip>}
                >
                  <Button
                    className="mr-0"
                    // variant="info"
                    disabled={
                      val.stepEmpat.tujuanPenggunaan === "2" ||
                      val.urlChecklist === "-"
                    }
                    style={{
                      cursor:
                        val.stepEmpat.tujuanPenggunaan === "2" &&
                        val.urlChecklist === "-"
                          ? "not-allowed"
                          : "pointer",
                      marginTop: 5,
                      backgroundColor: "#78AAFE",
                      border: 0,
                    }}
                    // onClick={() => {
                    //   // handleDetailsClick(val);
                    //   window.open(val.urlChecklist, "_blank");
                    // }}
                  >
                    <i class="fas fa-file-image"></i>
                  </Button>
                </OverlayTrigger> */}
              </>
            </>
          ),
        };
      });
      setListPengajuan(tmp);
    }
  }, [pengajuan.listPengajuan.data]);

  const options = [
    { value: 10, label: "10" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
  ];

  // React.useEffect(() => {
  //   let tmp =
  //     pengajuan.listPengajuan.data &&
  //     pengajuan.listPengajuan.data.map((val) => {
  //       return {
  //         ...val,
  //         namaCabangPencairan: !val.lokasiPencairan
  //           ? "-"
  //           : val.lokasiPencairan.namaCabang,
  //         action: (
  //           <>
  //             {" "}
  //             <Button
  //               className="mr-0"
  //               variant="info"
  //               style={{ marginTop: 5 }}
  //               onClick={() => handleDetailsClick(val)}
  //             >
  //               Details
  //             </Button>
  //           </>
  //         ),
  //       };
  //     });
  //   setListPengajuan(tmp);
  // }, [pengajuan.listPengajuan.data]);

  React.useEffect(() => {
    let tmp = [
      {
        value: "",
        isDisabled: false,
      },
      {
        value: "Menunggu Konfirmasi",
        label: "Menunggu Konfirmasi",
      },

      {
        value: "Diproses",
        label: "Diproses",
      },
      {
        value: "Disetujui",
        label: "Disetujui",
      },
      {
        value: "Revisi",
        label: "Revisi",
      },
      {
        value: "Ditolak",
        label: "Ditolak",
      },
    ];
    setListStatus(tmp);
  }, [pengajuan.listPengajuan.data, page, totalPerHalaman]);

  const getStatusStyle = (status) => {
    switch (status) {
      case "Menunggu Konfirmasi":
        return {
          fontWeight: "bold",
          backgroundColor: "#FFF5CD",
          textColor: "#FFAF05",
        };
      case "Diajukan":
        return {
          fontWeight: "bold",
          backgroundColor: "#BAD9FD",
          textColor: "#1776F1",
        };
      case "Diajukan (File Gagal Terkirim)":
        return {
          fontWeight: "bold",
          backgroundColor: "#E3CFD4",
          textColor: "#76424E",
        };
      case "Diproses":
        return {
          fontWeight: "bold",
          backgroundColor: "#FDDACB",
          textColor: "#F84B02",
        };
      case "Disetujui":
        return {
          fontWeight: "bold",
          backgroundColor: "#E3FCDB",
          textColor: "#5AC967",
        };
      case "Revisi":
        return {
          fontWeight: "bold",
          backgroundColor: "#FFE2E6",
          textColor: "#FF2B4B",
        };
      case "Ditolak":
        return {
          fontWeight: "bold",
          backgroundColor: "#E10F00",
          textColor: "#ffffff",
        };
      default:
        return {};
    }
  };

  const customStyles = {
    table: {
      style: {
        backgroundColor: "#ffffff",
      },
    },
    headRow: {
      style: {
        backgroundColor: "#f1f5f9", // Abu-abu biru profesional
        minHeight: "55px",
        borderTop: "1px solid #e2e8f0",
        borderBottom: "2px solid #e2e8f0",
      },
    },
    headCells: {
      style: {
        fontSize: "13px",
        fontWeight: "800",
        textTransform: "uppercase",
        color: "#475569",
        justifyContent: "flex-start", // Rata kiri agar lebih nyaman dibaca
        paddingLeft: "20px",
      },
    },
    rows: {
      style: {
        minHeight: "75px", // Row lebih tinggi agar data padat tidak terlihat sesak
        "&:not(:last-of-type)": {
          borderBottom: "1px solid #f1f5f9",
        },
        "&:hover": {
          backgroundColor: "#f8fafc",
          transition: "0.2s ease",
        },
      },
    },
    cells: {
      style: {
        fontSize: "14px",
        color: "#334155",
        justifyContent: "flex-start", // Konsisten rata kiri
        paddingLeft: "20px",
      },
    },
  };

  const colPengajuan = [
    {
      name: "NO",
      width: "100px",
      center: true,
      selector: (row, index) => index + pengajuan.listPengajuan.pagingCounter,
    },
    {
      name: "Referensi ID",
      minWidth: "300px",
      center: true,
      cell: (row) => (
        <div className="d-flex align-items-center justify-content-center">
          <b className="text-dark mr-2" style={{ fontSize: "13px" }}>
            {row.id_pinjaman}
          </b>
          <OverlayTrigger placement="top" overlay={<Tooltip>Salin ID</Tooltip>}>
            <i
              className="far fa-copy text-muted"
              style={{
                cursor: "pointer",
                fontSize: "14px",
                transition: "color 0.2s",
              }}
              onMouseOver={(e) =>
                (e.currentTarget.className = "far fa-copy text-primary")
              }
              onMouseOut={(e) =>
                (e.currentTarget.className = "far fa-copy text-muted")
              }
              onClick={() => {
                navigator.clipboard.writeText(row.id_pinjaman);
                Swal.fire({
                  title: "Tersalin!",
                  text: `ID ${row.id_pinjaman} berhasil disalin`,
                  icon: "success",
                  timer: 1000,
                  showConfirmButton: false,
                  position: "center",
                  width: "500px",
                });
              }}
            ></i>
          </OverlayTrigger>
        </div>
      ),
    },
    {
      name: "NAMA NASABAH",
      minWidth: "270px",
      center: false, // Memastikan header dan cell rata kiri
      cell: (row) => (
        <div className="w-100 py-2 d-flex justify-content-start align-items-center">
          <span
            className="fw-900 text-dark ml-1"
            style={{
              fontSize: "15px",
              // letterSpacing: "-0.3px",
            }}
          >
            {row.namaLengkap}
          </span>
        </div>
      ),
    },
    {
      name: "TUJUAN",
      minWidth: "150px",
      center: false,
      cell: (row) => {
        const isProduktif = row.stepEmpat.tujuanPenggunaan === "1";

        return (
          <div className="ml-1">
            <span
              className="badge bg-success text-white px-3 py-2 fw-800"
              style={{
                borderRadius: "8px",
                fontSize: "11px",
                letterSpacing: "0.5px",
              }}
            >
              {isProduktif ? "PRODUKTIF" : "LAINNYA"}
            </span>
          </div>
        );
      },
    },
    {
      name: "CABANG PENCAIRAN",
      minWidth: "260px",
      center: false, // Ubah jadi false agar header dan cell rata kiri
      cell: (row) => (
        <div className="w-100 d-flex justify-content-start align-items-center">
          <div
            className="px-3 py-1 rounded-pill bg-light border fw-700 text-dark d-flex align-items-center"
            style={{
              fontSize: "13px",
              minWidth: "fit-content", // Agar pill menyesuaikan panjang teks
              marginLeft: "5px", // Sedikit margin agar tidak nempel garis tabel
            }}
          >
            <i className="fas fa-university mr-2 text-primary"></i>
            {row.namaCabangPencairan}
          </div>
        </div>
      ),
    },
    {
      name: "SALES MARKETING",
      minWidth: "250px",
      center: false,
      cell: (row) => (
        <div className="text-center">
          <div className="fw-800 text-dark" style={{ fontSize: "14px" }}>
            {row.marketing.nama}
          </div>
        </div>
      ),
    },
    {
      name: "SALES SUPERVISOR",
      minWidth: "250px",
      center: false,
      cell: (row) => (
        <div className="text-center">
          <div className="fw-800 text-dark" style={{ fontSize: "14px" }}>
            {row.supervisor.nama}
          </div>
        </div>
      ),
    },
    {
      name: "TGL PENGAJUAN ",
      minWidth: "180px",
      center: true,
      cell: (row) => (
        <span
          className=""
          style={{ fontSize: "14px", color: "#334155", fontWeight: "700" }}
        >
          {moment(new Date(row.createdAt)).format("DD MMM YYYY")}
        </span>
      ),
    },
    {
      name: "TGL PENCAIRAN",
      minWidth: "180px",
      center: true,
      cell: (row) => (
        <span
          className=" text-success"
          style={{ fontSize: "14px", fontWeight: "900" }}
        >
          {row.tanggalPencairan || "-"}
        </span>
      ),
    },
    {
      name: "Status",
      minWidth: "170px",
      center: true,
      cell: (row) => {
        const statusStyle = getStatusStyle(row.statusPengajuan);
        return (
          <div
            style={{
              fontWeight: "800",
              fontSize: "10px",
              textTransform: "uppercase",
              backgroundColor: statusStyle.backgroundColor,
              color: statusStyle.textColor,
              padding: "6px 12px",
              borderRadius: "20px",
              width: "130px",
              textAlign: "center",
              border: `1px solid ${statusStyle.textColor}44`,
            }}
          >
            {row.statusPengajuan}
          </div>
        );
      },
    },
    {
      name: "NO REKENING KREDIT",
      minWidth: "200px",
      center: false,
      cell: (row) => (
        <div className="ml-1">
          <span
            className="fw-700 text-dark"
            style={{ fontSize: "14px", letterSpacing: "0.5px" }}
          >
            {!row.noRekeningKredit ? "-" : row.noRekeningKredit}
          </span>
        </div>
      ),
    },
    {
      name: "PERIODE REKON",
      minWidth: "200px",
      center: false,
      omit: !(auth.role === "super admin" || auth.role === "admin"),
      cell: (row) => (
        <div className="ml-1">
          <div className="d-flex align-items-center">
            <i
              className="far fa-calendar-check mr-2 text-primary"
              style={{ fontSize: "16px" }}
            ></i>
            <span className="fw-900 text-dark" style={{ fontSize: "16px" }}>
              {row.periodeRekon === "" || !row.periodeRekon
                ? "-"
                : moment(row.periodeRekon).format("DD MMM YYYY")}
            </span>
          </div>
        </div>
      ),
    },
    {
      name: "AKSI",
      width: "120px",
      cell: (row) => (
        <div style={{ transform: "scale(1.1)" }}>{row.action}</div>
      ),
    },
  ];

  React.useEffect(() => {
    jsonPengajuan(dispatch);
  }, []);

  React.useEffect(() => {
    let tmp = [{ value: "", label: "All" }];
    wilayah.allWilayah &&
      wilayah.allWilayah.map((val) => {
        // console.log(val, "VAL WILAYAH");
        tmp.push({
          value: val._id,
          label: val.namaWilayah,
        });
      });
    setListWilayah(tmp);
    let Obj = wilayah.allWilayah.find((x) => x.namaWilayah === "Gorontalo");
    // setIdWilayah({ value: Obj._id, label: Obj.namaWilayah });
    // console.log(Obj, ">>>>>>>>>>>>>>>>");
  }, [wilayah.allWilayah]);

  React.useEffect(() => {
    getAllWilayah(dispatch).then((response) => {
      // const dataCabang = response.data;
      // setTotalCbg(dataCabang);
    });
  }, []);

  React.useEffect(() => {
    setIsLoading(true);
    getAllPengajuan(dispatch, {
      tglAwal: "",
      tglAkhir: "",
      status:
        filterStatus === null || filterStatus.value === ""
          ? ""
          : filterStatus.value,
      cari: searchText,
      page: page + 1,
      limit: totalPerHalaman,
      idWilayah: idWilayah.value,
    })
      .then((response) => {
        // setLoading(false);
        setIsLoading(false);
      })
      .catch((error) => {
        // setLoading(false);
        setIsLoading(false);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Terjadi kesalahan saat memuat data.",
        });
      });
  }, [
    modalDetailPengajuan.modalDetailPengajuan,
    page,
    totalPerHalaman,
    idWilayah,
  ]);

  return (
    <>
      {modalDetailPengajuan.modalDetailPengajuan ? (
        <>
          <Container fluid className="px-4 py-4">
            <Row>
              <Col md="12">
                <Card
                  className="border-0"
                  style={{
                    borderRadius: "25px",
                    boxShadow: "0 10px 50px rgba(0,0,0,0.08)",
                    background: "#ffffff",
                  }}
                >
                  {/* HEADER SECTION */}
                  <div
                    className="p-4 d-flex align-items-center justify-content-between border-bottom"
                    style={{ borderColor: "#f1f5f9" }}
                  >
                    <div className="d-flex align-items-center">
                      <div
                        className="mr-3 d-flex align-items-center justify-content-center shadow"
                        style={{
                          width: "55px",
                          height: "55px",
                          background:
                            "linear-gradient(135deg, #f90203 0%, #2e3192 100%)",
                          borderRadius: "18px",
                          color: "white",
                        }}
                      >
                        <i className="fas fa-file-invoice-dollar fa-lg"></i>
                      </div>
                      <div>
                        <h3
                          className="m-0 font-weight-black text-dark"
                          style={{
                            letterSpacing: "-0.5px",
                            textTransform: "uppercase",
                            fontSize: "1.5rem",
                            fontWeight: "900",
                          }}
                        >
                          LIST PENGAJUAN
                        </h3>
                        <p className="text-muted m-0 small fw-700">
                          Manajemen Data & Monitoring Kredit Nasabah
                        </p>
                      </div>
                    </div>
                  </div>

                  <Card.Body className="p-4">
                    {/* BARIS FILTER - LEBIH MINIMALIS */}
                    <Row
                      className="mb-4 align-items-end"
                      style={{ gap: "0px" }}
                    >
                      <Col lg="4" md="6" className="mb-3 mb-lg-0">
                        <label className="fw-800 text-muted small ml-1 mb-2">
                          PENCARIAN CEPAT
                        </label>
                        <InputGroup
                          className="bg-light border-0"
                          style={{ borderRadius: "15px", padding: "5px 10px" }}
                        >
                          <Form.Control
                            className="bg-transparent border-0 fw-700"
                            style={{ height: "45px", fontSize: "14px" }}
                            value={searchText}
                            onChange={handleSearch}
                            placeholder="ID Referensi atau Nama Nasabah..."
                            onKeyDown={handleKeyDown}
                          />
                          {searchText && (
                            <InputGroup.Append>
                              <Button
                                variant="link"
                                className="text-muted"
                                onClick={handleClearSearch}
                              >
                                <i className="fas fa-times-circle"></i>
                              </Button>
                            </InputGroup.Append>
                          )}
                        </InputGroup>
                      </Col>

                      {/* <Col lg="3" md="6" className="mb-3 mb-lg-0">
                        <label className="fw-800 text-muted small ml-1 mb-2">
                          WILAYAH
                        </label>
                        <Select
                          classNamePrefix="react-select"
                          defaultValue={{ label: "Semua Wilayah", value: "" }}
                          onChange={(value) => setIdWilayah(value)}
                          options={listWilayah}
                          styles={{
                            control: (b) => ({
                              ...b,
                              borderRadius: "15px",
                              height: "55px",
                              border: "none",
                              backgroundColor: "#f8fafc",
                              fontWeight: "700",
                            }),
                          }}
                        />
                      </Col> */}

                      <Col lg="3" md="6" className="mb-3 mb-lg-0">
                        <label className="fw-800 text-muted small ml-1 mb-2">
                          STATUS
                        </label>
                        <Select
                          classNamePrefix="react-select"
                          value={filterStatus}
                          onChange={(selected) => {
                            setFilterStatus(selected);
                            setPilihOpsi(selected.value);
                          }}
                          options={[
                            { value: "", label: "Tampilkan Semua" },
                            ...listStatus,
                          ]}
                          styles={{
                            control: (b) => ({
                              ...b,
                              borderRadius: "15px",
                              height: "55px",
                              border: "none",
                              backgroundColor: "#f8fafc",
                              fontWeight: "700",
                            }),
                          }}
                        />
                      </Col>

                      <Col lg="2" md="6">
                        <Button
                          className="btn-block border-0 shadow-sm fw-900"
                          style={{
                            height: "55px",
                            borderRadius: "15px",
                            background: "#f90203",
                            color: "white",
                            fontSize: "14px",
                            letterSpacing: "1px",
                          }}
                          onClick={handleFilterChange}
                        >
                          <i className="fas fa-filter mr-2"></i> FILTER
                        </Button>
                      </Col>
                    </Row>

                    {/* TABLE SECTION */}
                    {isLoading ? (
                      <div
                        className="text-center py-5"
                        style={{ background: "#f8fafc", borderRadius: "20px" }}
                      >
                        <Dna visible={true} height="100" width="100" />
                        <h6 className="mt-3 fw-800 text-muted">
                          LOADING DATA NASABAH...
                        </h6>
                      </div>
                    ) : (
                      <div className="table-responsive shadow-none border-0 mt-2">
                        <DataTable
                          columns={colPengajuan}
                          data={listPengajuan}
                          customStyles={customStyles}
                          paginationPerPage={totalPerHalaman}
                          progressPending={isLoading}
                        />
                      </div>
                    )}

                    {/* FOOTER & PAGINATION */}
                    <div
                      className="mt-5 d-flex flex-column flex-md-row align-items-center justify-content-between bg-light p-3"
                      style={{ borderRadius: "20px" }}
                    >
                      <div className="d-flex align-items-center mb-3 mb-md-0">
                        <span className="fw-800 text-muted small mr-3">
                          TAMPILKAN
                        </span>
                        <div style={{ width: "90px" }}>
                          <Select
                            classNamePrefix="react-select"
                            value={options.find(
                              (o) => o.value === totalPerHalaman,
                            )}
                            onChange={handlePageSizeChange}
                            options={options}
                            styles={{
                              control: (b) => ({
                                ...b,
                                borderRadius: "10px",
                                minHeight: "35px",
                                fontWeight: "800",
                              }),
                            }}
                          />
                        </div>
                        <span className="fw-800 text-muted small ml-3">
                          BARIS PER HALAMAN
                        </span>
                      </div>

                      <ReactPaginate
                        forcePage={page}
                        containerClassName="paginations m-0"
                        pageCount={pengajuan.listPengajuan.totalPages}
                        pageRangeDisplayed={3}
                        marginPagesDisplayed={1}
                        onPageChange={(val) => setPage(val.selected)}
                        previousLabel={<i className="fas fa-arrow-left"></i>}
                        nextLabel={<i className="fas fa-arrow-right"></i>}
                      />
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Container>
        </>
      ) : (
        <>
          <DetailPengajuan />
        </>
      )}
    </>
  );
}

export default Pengajuan;
